import {useCallback} from 'react';
import {useSelector} from 'react-redux';

import {
    selectIsAnyConsumerProducts,
    selectIsConsumerDataFetched,
    selectIsConsumerProductsFetched,
} from '@/state/selectors/consumer';
import {
    selectIsClubPlusSubscriber,
    selectIsLoyaltyJourneysFetched,
    selectIsLoyaltyMember,
} from '@/state/selectors/consumerLoyalty';
import {isBannerEnabled} from '@/utils/bannerUtils';

const resolve = (isFetched: boolean, value: boolean) => (isFetched ? value : undefined);

const useIsBannerEnabled = () => {
    const isProductsFetched = useSelector(selectIsConsumerProductsFetched);
    const isConsumerDataFetched = useSelector(selectIsConsumerDataFetched);
    const isLoyaltyJourneysFetched = useSelector(selectIsLoyaltyJourneysFetched);

    const isDeviceRegistered = resolve(isProductsFetched, useSelector(selectIsAnyConsumerProducts));
    const isLoyaltyMember = resolve(isConsumerDataFetched, useSelector(selectIsLoyaltyMember));
    const isClubPlusSubscriber = resolve(isLoyaltyJourneysFetched, useSelector(selectIsClubPlusSubscriber));

    return useCallback(
        (banner: any) => isBannerEnabled(banner, {isDeviceRegistered, isLoyaltyMember, isClubPlusSubscriber}),
        [isDeviceRegistered, isLoyaltyMember, isClubPlusSubscriber]
    );
};

export default useIsBannerEnabled;
